// src/common/helpers/checkItemAvailability.ts

import { AvailabilityStatus } from "../../types/enums";
import { AvailabilityParams, AvailabilityResult } from "../../types/types";

export const checkItemAvailability = ({
  item,
  forceStore,
  selectedStoreIds,
}: AvailabilityParams): AvailabilityResult => {
  // 1. Товар с учётом остатков
  if (item.useStock) {
    if (!forceStore) {
      const hasStock = item.stock_stores?.some((ss) => ss.quantity > 0) ?? false;
      return {
        available: hasStock,
        status: hasStock ? AvailabilityStatus.IN_STOCK : AvailabilityStatus.OUT_OF_STOCK,
      };
    }

    if (selectedStoreIds.length === 0) {
      return {
        available: false,
        status: AvailabilityStatus.NO_STORE_SELECTED,
      };
    }

    const hasStockInSelected = selectedStoreIds.some((storeId) =>
      item.stock_stores?.some((ss) => ss.store?.id === storeId && ss.quantity > 0),
    );
    return {
      available: hasStockInSelected,
      status: hasStockInSelected ? AvailabilityStatus.IN_STOCK : AvailabilityStatus.OUT_OF_STOCK,
    };
  }

  // 2. Товар без учёта остатков (стоп-листы)
  // Доступен, если есть хоть одна точка, где не запрещён
  const availableAnywhere = item.item_stops?.some((stop) => !stop.isStopped) ?? true;

  if (!forceStore) {
    return {
      available: availableAnywhere,
      status: availableAnywhere ? AvailabilityStatus.IN_STOCK : AvailabilityStatus.OUT_OF_STOCK,
    };
  }

  if (selectedStoreIds.length === 0) {
    return {
      available: false,
      status: AvailabilityStatus.NO_STORE_SELECTED,
    };
  }

  const availableInSelected = selectedStoreIds.some(
    (storeId) => !item.item_stops?.some((stop) => stop.storeId === storeId && stop.isStopped),
  );
  return {
    available: availableInSelected,
    status: availableInSelected ? AvailabilityStatus.IN_STOCK : AvailabilityStatus.OUT_OF_STOCK,
  };
};